import React from 'react';
import { useSelector } from 'react-redux';
import {
  Grid,
  Container,
  Divider,
  makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';

import Wizard from '../../components/Wizard';
import TypeOfInsurance from '../../components/TypeOfInsurance';
import Discount from '../../components/Discount';

import './style.scss';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginBottom: 36,
    marginTop: 0,
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      marginTop: 16,
      width: '80%',
    },
  },
  wizardContainer: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      borderBottom: '1px solid #cfdae2',
      paddingBottom: 20,
      background: `linear-gradient(0deg, #F5F8FA, #F5F8FA);`,
    },
  },
  dividerRoot: {
    width: 232,
    margin: '20px auto 30px',
    border: '1px solid #e0e0e0',
    [theme.breakpoints.down('xs')]: {
      width: '70%',
    },
  },
}));

const Suggestion = ({ discount, suggestion, withBadge }) => {
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <div className='suggestion-container'>
      {suggestion}
      {discount && withBadge && !xs && <Discount discount={discount} />}
    </div>
  );
};

export default function WizardLayout({
  activeStep,
  suggestion,
  withoutSuggestion,
  withBadge,
  children,
}) {
  const { insurance, plans, insuranceSelected } = useSelector(
    ({ insurances, insurancePlans }) => ({
      plans: insurancePlans.plans,
      insurance: insurances.selected,
      insuranceSelected: insurances.selected.insuranceName,
    })
  );

  const { logo, title, subTitle, insuranceName } = insurance || {};

  const classes = useStyles();
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down('xs'));

  const discount =
    insuranceSelected === 'AUTOMOTOR'
      ? 50
      : plans &&
        plans[0] &&
        plans[0].description &&
        plans[0].description.split('|')[1];

  return (
    <Container
      classes={{ root: classes.mainContainer }}
      disableGutters={xs && true}
    >
      <Grid container item xs={12} direction='column' alignItems='center'>
        <Grid item xs={12} classes={{ root: classes.wizardContainer }}>
          <Wizard activeStep={activeStep} type={insuranceName} />
        </Grid>
        <Grid item xs={12} container>
          <TypeOfInsurance insuranceLogo={logo} insuranceTitle={title} />
        </Grid>
        <Grid item xs={10} sm={12} container justify='center'>
          {!withoutSuggestion && (
            <div className='wizard-suggestion'>
              {suggestion ? (
                <Suggestion
                  suggestion={suggestion}
                  discount={discount}
                  withBadge={withBadge}
                />
              ) : (
                subTitle && (
                  <>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: subTitle,
                      }}
                    ></span>
                  </>
                )
              )}
              {(suggestion || subTitle) && (
                <Divider
                  classes={{
                    root: classes.dividerRoot,
                  }}
                />
              )}
            </div>
          )}
        </Grid>
        <Grid item xs={12} container justify='center'>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
}
